import React from 'react';

const SignupHeader = ({ mounted, currentStep }) => {
  return (
    <div className="text-center mb-8">
      <div className={`flex items-center justify-center space-x-3 mb-6 transform transition-all duration-700 ease-out ${
        mounted ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-8 opacity-0 scale-95'
      }`}>
        <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg animate-float-gentle">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-emerald-700 bg-clip-text text-transparent">
            Pengravity
          </h1>
          <p className="text-xs text-gray-500 font-medium">Learning Management System</p>
        </div>
      </div>
      
      <div className={`transform transition-all duration-800 ease-out delay-200 ${
        mounted ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}>
        <h2 className="text-2xl lg:text-3xl font-extrabold text-gray-900 mb-2">
          Become an Instructor
        </h2>
        <p className="text-base text-gray-600 font-light">
          Step {currentStep} of 3
        </p>
      </div>
    </div>
  );
};

export default SignupHeader;